import React, { useEffect } from "react";
import ProgressBar from "react-toolbox/lib/progress_bar";
import styles from "application/components/Login.css";
import { useSelector } from "react-redux";
import { notBlank } from "../../util/ext";
import { useHistory } from "react-router-dom";

const Login = () => {
  const auth = useSelector(state => state.auth);
  const history = useHistory();
  useEffect(() => {
    // Catch if user is already logged in
    if (notBlank(auth.user)) {
      history.replace("/home");
    }
  }, [auth, history]);
  return (
    <div className={styles.container}>
      <ProgressBar theme={styles} type="circular" mode="indeterminate" />
    </div>
  );
};

export default Login;
